import React from "react";
import { useLocation } from "react-router-dom";
import s from "./styles.module.scss";
import { PUBLIC_HEADER_ROUTS } from "../../static/constants";

const PageContainer = ({ children, className = "", isShowIcon = false }) => {
  const { pathname } = useLocation();
  const showHeader = PUBLIC_HEADER_ROUTS.includes(pathname);

  return (
    <div
      className={`${s.pageContainer} ${showHeader ? s.showHeader : ""} ${
        isShowIcon ? s.circleIcon : ""
      }
      ${className}`}
    >
      <div className={s.container}>{children}</div>
    </div>
  );
};

export default PageContainer;
